class LoyaltyPoints {
  constructor() {
    this.setLoyaltyPoints();
  }

  setLoyaltyPoints() {
    let LoyaltyPointsContainer = document.querySelector('.lion-loyalty--vouchers');
    let userLoyaltyPoints = window.themeVariables.lionLoyalty.lionLoyaltyUserPoints;
    let nextTier;

    if (!LoyaltyPointsContainer) {
      return;
    }

    let loyaltyPoints = LoyaltyPointsContainer.querySelectorAll('.voucher');
    if (loyaltyPoints) {
      loyaltyPoints.forEach((element, index) => {
        
        if (userLoyaltyPoints <= element.dataset.points) {
          console.log(element.dataset.points);
        }

        if (index === loyaltyPoints.length - 1 ) {
          let maxPoints = parseInt(element.dataset.points);
          let currentPercentage = (100 * userLoyaltyPoints) / maxPoints;
          let userPercentage = currentPercentage + '%';
          document.documentElement.style.setProperty('--loyaltyRangePercentage', userPercentage);
        }
      });
    }
  }
}

export default LoyaltyPoints;